import React from "react";
import Container from "./Container";
import GrowLogo from "../assets/images/grow-logo.svg";
import AppStore from "../assets/images/app-store.svg";
import GooglePlay from "../assets/images/google-play.svg";
import { Link } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import useLocale from "../../src/locales/index";

const Footer = () => {
  const cAccept = localStorage.getItem("grow-cookies");
  const cookieAccept = JSON.parse(cAccept);
  const { textData } = useLocale();

  const links = [
    { to: "/history", text: textData.History, analyticsName: "history" },
    {
      to: "/privacy-policy",
      text: textData.PrivacyPolicy,
      analyticsName: "privacy_policy",
    },
    {
      to: "/terms-of-use",
      text: textData.TermsofUse,
      analyticsName: "terms_and_condition",
    },
    { to: "/about-us", text: textData.Aboutus, analyticsName: "about_us" },
    {
      to: "/disclaimer",
      text: textData.Disclaimer,
      analyticsName: "disclaimer",
    },
    {
      to: "/faq",
      text: textData.Faq,
      analyticsName: "faq",
    },
    {
      to: "/blog",
      text: textData.Blog,
      analyticsName: "blog",
    },
    {
      to: "/settings",
      text: textData.settings?.title || "Settings",
      analyticsName: "settings",
    },
  ];

  return (
    <div className="bg-primary-bg sm:mt-[75px] mt-[24px] ">
      <Container>
        <div className="sm:flex block justify-between items-center pt-6  ">
          <div className="flex lg:justify-start justify-center sm:p-0">
            <Link
              to="/"
              onClick={() => {
                if (window.location.pathname === "/") {
                  document.documentElement.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
                }
              }}
            >
              {" "}
              <img
                src={GrowLogo}
                alt="Grow-Logo"
                className="md:h-auto h-[44px]"
              />
            </Link>
          </div>

          <div className="flex md:justify-around  justify-center  md:gap-[10px] sm:gap-[20px] gap-[20px] md:mt-0 mt-[20px]">
            <div>
              <button>
                <a
                  href="https://apps.apple.com/us/app/grow-life-fund/id6496204376"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={AppStore}
                    alt="App-Store-Icon"
                    className="md:h-auto h-[36px]"
                  />
                </a>
              </button>
            </div>
            <div>
              <button>
                <a
                  href="https://play.google.com/store/apps/details?id=com.growlifefund&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={GooglePlay}
                    alt="Google-Store-Icon"
                    className="md:h-auto h-[36px]"
                  />
                </a>
              </button>
            </div>
          </div>
        </div>
        <div className=" border-b-[2px] border-solid border-gray-light pt-8"></div>
        <div className="my-[34px]">
          <div className="sm:flex block justify-center text-center items-center sm:text-[18px] text-[16px] lg:gap-10 md:gap-[20px] sm:gap-[16px] gap-[10px]">
            {links?.map((link, index) => (
              <div
                key={index}
                className={`lg:mt-0 mt-${
                  index === 0 ? "[0]" : "[0]"
                } font-lato-regular-400 sm:text-base text-sm`}
              >
                <Link
                  onClick={() =>
                    cookieAccept &&
                    analytics &&
                    logEvent(analytics, `click_${link?.analyticsName}`)
                  }
                  to={link?.to}
                >
                  {link?.text}
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="border-b-2  border-[#DCE5E5] pb-5  ">
          <div className="text-gray-font  sm:text-[14px] text-[12px] font-lato-regular-400">
            <span className="font-bold">{textData.footertitle}:</span>
            {textData.footerdescription}
          </div>
        </div>
        <div className="text-center pt-[20px] pb-[20px] sm:text-base text-[12px] text-gray-font font-lato-regular-400">
          {textData.copyRightText}
        </div>
      </Container>
    </div>
  );
};

export default Footer;
